import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer1FrezowaniePni from "../../components/offer/1frezowaniePni";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Frezowanie pni i usuwanie karp po wycince | Gdańsk, Gdynia, Wejherowo</title>
        <meta name="title" content="Frezowanie pni i usuwanie karp po wycince | Gdańsk, Gdynia, Wejherowo" />
        <meta
          name="description"
          content="Szybkie i bezinwazyjne frezowanie pni drzew po wycince przy użyciu specjalistycznych frezarek. Oczyszczamy teren pod inwestycje w Trójmieście, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Frezowanie pni i usuwanie karp po wycince | Gdańsk, Gdynia, Wejherowo"
        />
        <meta
          property="og:description"
          content="Szybkie i bezinwazyjne frezowanie pni drzew po wycince przy użyciu specjalistycznych frezarek. Oczyszczamy teren pod inwestycje w Trójmieście, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer1FrezowaniePni />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
